'use strict';

(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]));
  const models = {Scania:['Serie 4','Serie 5','Serie 6 NTG'],Volvo:['FH','FM'],Volkswagen:['Constellation','Delivery']};

  function track(event, details = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event, ...details});
  }

  function notify(message) {
    const toast = $('#theme-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(notify.timer);
    notify.timer = setTimeout(() => { toast.hidden = true; }, 2800);
  }

  function stockMarkup(option, container) {
    const tracked = option.dataset.tracked === 'true';
    const available = option.dataset.available === 'true';
    const quantity = Number(option.dataset.quantity || 0);
    const showQuantity = container.dataset.showQuantity === 'true';
    const threshold = Number(container.dataset.lowThreshold || 5);
    if (tracked && quantity > 0) {
      const low = quantity <= threshold;
      return `<span class="stock-label ${low ? 'low-stock' : 'in-stock'}"><span class="stock-dot"></span>${low ? 'Últimas unidades' : 'En stock'}</span>${showQuantity ? `<small>${quantity} ${quantity === 1 ? 'unidad disponible' : 'unidades disponibles'}</small>` : ''}`;
    }
    if (tracked && available) return '<span class="stock-label unknown-stock"><span class="stock-dot"></span>Disponible por encargo</span><small>Confirma el plazo con nuestro equipo</small>';
    if (tracked) return '<span class="stock-label no-stock"><span class="stock-dot"></span>Agotado</span>';
    if (available) return '<span class="stock-label unknown-stock"><span class="stock-dot"></span>Consultar stock</span><small>Inventario por confirmar</small>';
    return '<span class="stock-label no-stock"><span class="stock-dot"></span>No disponible</span>';
  }

  function updateVariant(select, shouldTrack = false) {
    const section = select.closest('[data-product-section]');
    const option = select.selectedOptions[0];
    if (!section || !option) return;
    const priced = Number(option.dataset.price) > 0;
    const available = option.dataset.available === 'true';
    $('[data-variant-price]', section).textContent = priced ? option.dataset.money : 'Consultar precio';
    $('[data-variant-sku]', section).textContent = option.dataset.sku || 'Por confirmar';
    $('[data-purchase-area]', section).hidden = !(priced && available);
    $('[data-cart-submit]', section).disabled = !(priced && available);
    $('[data-availability]', section).textContent = !available ? 'Esta variante no está disponible para compra directa. Puedes consultarla con nuestro equipo.' : (!priced ? 'Precio por confirmar; agrégala a tu cotización.' : '');
    const stock = $('[data-stock-status]', section);
    if (stock) stock.innerHTML = stockMarkup(option, stock);
    const photo = $('.detail-image', section);
    if (option.dataset.photo && photo) {
      photo.src = option.dataset.photo;
      photo.srcset = '';
      photo.alt = option.dataset.photoAlt || '';
    }
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
    const quote = $('[data-add-quote]', section);
    if (quote) {
      quote.dataset.sku = option.dataset.sku || '';
      quote.dataset.variant = option.value;
      quote.dataset.variantTitle = option.dataset.variantTitle || '';
      quote.dataset.url = url.href;
      if (option.dataset.photo) quote.dataset.image = option.dataset.photo;
    }
    if (shouldTrack) track('impactrucks_variant_change', {variant_id: option.value, sku: option.dataset.sku || ''});
  }

  $$('[data-variant-select]').forEach(select => updateVariant(select));
  document.addEventListener('change', event => {
    if (event.target.matches('[data-variant-select]')) updateVariant(event.target, true);
    if (event.target.matches('[data-finder-brand]')) {
      const form = event.target.closest('[data-model-finder]');
      const modelSelect = $('[data-finder-model]', form);
      modelSelect.innerHTML = '<option value="">Todos los modelos</option>' + (models[event.target.value] || []).map(model => `<option>${escapeHtml(model)}</option>`).join('');
    }
  });
  document.addEventListener('shopify:section:load', event => $$('[data-variant-select]', event.target).forEach(select => updateVariant(select)));

  document.addEventListener('submit', event => {
    const finder = event.target.closest('[data-model-finder]');
    if (finder) {
      const brand = $('[data-finder-brand]', finder).value;
      if (!brand) {
        event.preventDefault();
        $('[data-finder-brand]', finder).focus();
        return;
      }
      const model = $('[data-finder-model]', finder).value;
      $('[data-finder-query]', finder).value = `${brand} ${model}`.trim();
      track('impactrucks_model_search', {brand, model});
    }
    if (event.target.id === 'ProductForm') {
      const select = $('[data-variant-select]', event.target.closest('[data-product-section]'));
      const option = select?.selectedOptions[0];
      if (!option || Number(option.dataset.price) <= 0 || option.dataset.available !== 'true') {
        event.preventDefault();
        openQuote();
      }
    }
  });

  document.addEventListener('click', event => {
    const galleryButton = event.target.closest('[data-gallery-image]');
    if (galleryButton) {
      const section = galleryButton.closest('[data-product-section]');
      const image = $('.detail-image', section);
      if (image) {
        image.src = galleryButton.dataset.galleryImage;
        image.srcset = '';
        image.alt = galleryButton.dataset.imageAlt || '';
        $$('[data-gallery-image]', section).forEach(button => button.classList.toggle('is-active', button === galleryButton));
      }
    }
    const filterButton = event.target.closest('[data-toggle-filters]');
    if (filterButton) {
      const sidebar = $('[data-filter-sidebar]');
      const open = sidebar.classList.toggle('is-open');
      filterButton.setAttribute('aria-expanded', String(open));
      filterButton.textContent = open ? 'Ocultar filtros' : 'Mostrar filtros';
    }
    const menuButton = event.target.closest('[data-toggle-menu]');
    if (menuButton) {
      const navigation = $('[data-navigation]');
      const open = navigation.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
      $('.sr-only', menuButton).textContent = open ? 'Cerrar menú' : 'Abrir menú';
    }
    if (event.target.closest('[data-navigation] a') && matchMedia('(max-width: 780px)').matches) {
      $('[data-navigation]')?.classList.remove('is-open');
      $('[data-toggle-menu]')?.setAttribute('aria-expanded', 'false');
    }
    const trackedWhatsApp = event.target.closest('[data-track-whatsapp]');
    if (trackedWhatsApp) track('impactrucks_whatsapp_click', {placement: trackedWhatsApp.dataset.trackWhatsapp});
  });

  const veil = $('#quote-veil');
  const quoteForm = $('#QuoteContactForm');
  const storageKey = 'impactrucks-theme-quote-v2';
  let quoteList = [];
  let previousFocus;

  function safeUrl(value) {
    try {
      const url = new URL(value, location.origin);
      return ['https:', 'http:'].includes(url.protocol) ? url.href : '';
    } catch { return ''; }
  }

  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) || localStorage.getItem('impactrucks-theme-quote-v1') || '[]');
    if (Array.isArray(saved)) quoteList = saved.filter(item => typeof item.id === 'string' && typeof item.title === 'string' && Number.isInteger(item.qty) && item.qty > 0).slice(0, 50).map(item => ({...item, qty: Math.min(item.qty, 99)}));
  } catch {}

  function renderQuote() {
    const count = quoteList.reduce((total, item) => total + item.qty, 0);
    $$('[data-quote-count]').forEach(element => { element.textContent = count; });
    const items = $('#quote-items');
    if (!items) return;
    items.innerHTML = quoteList.length ? quoteList.map(item => {
      const image = safeUrl(item.image);
      const productUrl = safeUrl(item.url);
      return `<div class="line-item">${image ? `<img src="${escapeHtml(image)}" alt="">` : ''}<div style="flex:1"><strong>${productUrl ? `<a href="${escapeHtml(productUrl)}">${escapeHtml(item.title)}</a>` : escapeHtml(item.title)}</strong><small>${item.variantTitle ? `${escapeHtml(item.variantTitle)} · ` : ''}Cód. ${escapeHtml(item.sku || 'Por confirmar')}</small><div class="quantity"><button type="button" data-change-quote="${escapeHtml(item.id)}" data-delta="-1" aria-label="Quitar una unidad">−</button><span>${item.qty}</span><button type="button" data-change-quote="${escapeHtml(item.id)}" data-delta="1" aria-label="Agregar una unidad">+</button><button type="button" class="remove" data-remove-quote="${escapeHtml(item.id)}">Eliminar</button></div></div></div>`;
    }).join('') : '<p class="inline-note">Agrega repuestos del catálogo o escribe tu consulta en el formulario.</p>';
  }

  function saveQuote() {
    try { localStorage.setItem(storageKey, JSON.stringify(quoteList)); } catch {}
    renderQuote();
  }

  function openQuote() {
    if (!veil) return;
    previousFocus = document.activeElement;
    veil.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => $('#quote-title', veil)?.focus());
    track('impactrucks_quote_open');
  }

  function closeQuote() {
    if (!veil) return;
    veil.hidden = true;
    document.body.style.overflow = '';
    previousFocus?.focus();
  }

  function addVehicle() {
    const container = $('#quote-vehicles');
    if (!container) return;
    const row = document.createElement('div');
    row.className = 'vehicle-row';
    row.innerHTML = '<select aria-labelledby="QuoteVehiclesLabel"><option value="">Selecciona un modelo</option>' + Object.entries(models).flatMap(([brand, modelList]) => modelList.map(model => `<option>${escapeHtml(brand)} ${escapeHtml(model)}</option>`)).join('') + '</select><button type="button" data-remove-vehicle aria-label="Eliminar camión">×</button>';
    container.append(row);
  }

  function validateQuote() {
    const messageField = $('[name="quote_message"]', quoteForm);
    messageField.setCustomValidity('');
    if (!quoteList.length && !messageField.value.trim()) {
      messageField.setCustomValidity('Indica el repuesto que necesitas o agrega uno del catálogo.');
      messageField.reportValidity();
      return false;
    }
    return quoteForm.reportValidity();
  }

  function quoteText() {
    const data = new FormData(quoteForm);
    const name = String(data.get('contact[name]') || '').trim();
    const email = String(data.get('contact[email]') || '').trim();
    const phone = String(data.get('contact[phone]') || '').trim();
    const message = String(data.get('quote_message') || '').trim();
    const vehicles = $$('#quote-vehicles select').map(select => select.value).filter(Boolean);
    let text = `Hola IMPACTRUCKS, soy ${name}. Quiero cotizar:`;
    if (email) text += `\nCorreo: ${email}`;
    if (phone) text += `\nWhatsApp: ${phone}`;
    if (vehicles.length) text += `\nCamiones: ${vehicles.join(', ')}`;
    quoteList.forEach(item => {
      text += `\n• ${item.qty} × ${item.title}${item.variantTitle ? ` / ${item.variantTitle}` : ''} | Código ${item.sku || 'Por confirmar'}`;
      if (safeUrl(item.url)) text += `\n  ${safeUrl(item.url)}`;
    });
    if (message) text += `\n\nConsulta: ${message}`;
    text += '\n\nFavor confirmar precio, IVA, compatibilidad, disponibilidad y plazo de despacho.';
    return text;
  }

  if (veil && quoteForm) {
    renderQuote();
    addVehicle();
    if ($('[data-quote-success]', quoteForm) || $('.errors', quoteForm)) openQuote();

    $('[name="quote_message"]', quoteForm).addEventListener('input', event => event.target.setCustomValidity(''));
    quoteForm.addEventListener('submit', event => {
      const email = $('[data-quote-email]', quoteForm);
      email.required = true;
      if (!validateQuote()) { event.preventDefault(); return; }
      $('[data-quote-body]', quoteForm).value = quoteText();
      track('impactrucks_quote_email', {items: quoteList.length});
    });

    $('[data-submit-whatsapp]', quoteForm).addEventListener('click', () => {
      $('[data-quote-email]', quoteForm).required = false;
      if (!validateQuote()) return;
      const phone = veil.dataset.whatsapp.replace(/\D/g, '');
      if (phone.length < 9) { notify('Configura un número de WhatsApp válido en el tema.'); return; }
      track('impactrucks_quote_whatsapp', {items: quoteList.length});
      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(quoteText())}`, '_blank', 'noopener');
    });

    veil.addEventListener('click', event => { if (event.target === veil) closeQuote(); });
    document.addEventListener('keydown', event => {
      if (veil.hidden) return;
      if (event.key === 'Escape') closeQuote();
      if (event.key === 'Tab') {
        const elements = $$('a,button,input,select,textarea,[tabindex="0"]', veil).filter(element => !element.disabled && !element.hidden);
        const first = elements[0];
        const last = elements.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('button,a');
    if (!button) return;
    if (button.hasAttribute('data-open-quote')) { event.preventDefault(); openQuote(); }
    if (button.hasAttribute('data-close-quote')) closeQuote();
    if (button.hasAttribute('data-add-quote')) {
      const id = `${button.dataset.id}-${button.dataset.variant || button.dataset.sku || 'default'}`;
      const existing = quoteList.find(item => item.id === id);
      if (existing) existing.qty = Math.min(99, existing.qty + 1);
      else quoteList.push({id, title: button.dataset.title, sku: button.dataset.sku, variantTitle: button.dataset.variantTitle, image: button.dataset.image, url: button.dataset.url, qty: 1});
      saveQuote();
      notify('Repuesto agregado a tu lista de cotización');
      track('impactrucks_quote_add', {product_id: button.dataset.id, variant_id: button.dataset.variant || '', sku: button.dataset.sku || ''});
    }
    if (button.hasAttribute('data-remove-quote')) { quoteList = quoteList.filter(item => item.id !== button.dataset.removeQuote); saveQuote(); }
    if (button.hasAttribute('data-change-quote')) { const item = quoteList.find(entry => entry.id === button.dataset.changeQuote); if (item) item.qty = Math.min(99, Math.max(1, item.qty + Number(button.dataset.delta))); saveQuote(); }
    if (button.hasAttribute('data-add-vehicle')) addVehicle();
    if (button.hasAttribute('data-remove-vehicle')) { button.parentElement.remove(); if (!$('#quote-vehicles').children.length) addVehicle(); }
  });
})();
